import {
  Mesh,
  DoubleSide,
  MeshBasicMaterial,
  PlaneGeometry,
  BufferGeometry,
  ShaderMaterial,
  VideoTexture,
  BufferAttribute,
  Vector3
} from 'three';

import { VRObject3D } from './VRObject3D';
import { borderMaterial, textureLoader, linkGeometry, chairPlaneGeometry, chairCircleGeometry } from './helpers/texturesAndGeometries';
import { videoTextureShaderProps } from './constants/shader';
import { SCENE_INTERACTION } from '../../constants/scene';
import { waitForElement } from './helpers/worldHelpers';
import { SCENE_EVENTS } from '../MVC/Model';
import { SOCKET_EVENTS } from '../../socket/Socket';
import { waitForSrcObject } from '../MVC/dataHelpers';

export const SCREEN_SHARE_SEAT_TYPE = {
  CHAIR: "chair",
  SEAT: "screen",
}


class VRTourScreenShare extends VRObject3D {

  constructor(containerName, camera, texture, x, y, z, model) {

    super(containerName);

    this.model = model;
    this.camera = camera;
    this.link = '';
    this.material = new MeshBasicMaterial({ map: texture, side: DoubleSide, transparent: true });

    this.videoId = "TOUR-SCREEN-SHARE";

    this.clickable = false;

    this.cameraGeometry = chairCircleGeometry;
    this.screenShareGeometry = chairPlaneGeometry;

    this.mesh = new Mesh(this.model.editMode ? this.screenShareGeometry : this.cameraGeometry, this.material);
    this.mesh.type = 'tourScreenShare';
    this.mesh.name = 'tourScreenShare';
    this.name = 'tourScreenShare';


    // this.borderMesh = new Mesh(linkGeometry, borderMaterial);
    // this.borderMesh.renderOrder = -1;
    // this.borderMesh.type = 'tourScreenShare';
    // !this.model.editMode && this.mesh.add(this.borderMesh);

    this.videoMaterial = new MeshBasicMaterial({
      side: DoubleSide,
      transparent: true,
      depthWrite: true,
      depthTest: true,
      // blending: NormalBlending
    });

    // INIT
    this.camera !== null ? this._setInitialPosRot() : this.setPosition(x, y, z);


    // this.chairMesh = this.mesh = new Mesh(this.model.editMode ? chairPlaneGeometry : chairCircleGeometry, this.material);
    // this.screenShare = new Mesh(this.model.editMode ? chairPlaneGeometry : chairCircleGeometry, this.material);
    // const { position } = this.mesh;
    // this.chairMesh.position.copy(new Vector3(position.x, position.y, position.z));
    // this.screenShare.position.copy(new Vector3(position.x, position.y, position.z));
    // this.add(this.chairMesh);
    // this.add(this.screenShare);

    this.add(this.mesh);
    this.mesh.groupDetails = { title: $trans('bagless-room'), icon: 'share', editTitle: $trans('edit-bagless-room'), dataLang: 'edit-bagless-room' }

    this.editControls();
    this.settingsMesh && (this.settingsMesh.visible = false);

    this.model.addEventListener(SCENE_INTERACTION.TOUR_SET_OCCUPIED_SCREEN_SHARE_SEATS, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.STREAM_RECIEVED, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.socket && this.model.socket.addEventListener(SOCKET_EVENTS.USER_JOINED_SCENE, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.socket && this.model.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED, async (e) => {
      const state = this.getState();
      // this.showRightMaterial();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.STREAM_REMOVED, (e) => {
      const state = this.getState();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.SCREEN_SHARE_STREAM_RECIEVED, async (e) => {
      const state = this.getState();
      if (!state.occupied) {
        this.standUp();
      } else {
        const userData = this.model.socket.getUsersObject()[state.occupied];
        this.takeSeat(userData);
      }
    });
    this.model.addEventListener(SCENE_INTERACTION.TOUR_MODE_USER_SCREEN_SHARE_SEAT_STAND_UP, async (e) => {
      this.standUp();
    });

    this.isSeatOccupiedByUser = () => {
      if (this.model.editMode) {
        return;
      }
      const occupiedSeats = this.model.socket.getTourOccupiedScreenShareSeats();
      if (!occupiedSeats[this.dbConfig.id]) {
        this.screenShareStreamId = null;
        // this.standUp()
      }
      if (occupiedSeats[this.dbConfig.id]) {
        this.occupySeat(this.model.socket.getUsersObject()[occupiedSeats[this.dbConfig.id]])
      }
      return occupiedSeats[this.dbConfig.id];
    }
    //result
    return this;
  }


  setDbConfig(config, forceUrl = false) {
    super.setDbConfig(config);
  }


  async takeSeat() {
    this.state = this.getState();
    const { byMe, videoName } = this.state;
    this.mesh.visible = true;

    $(`.indicator-${this.mesh.id}`).addClass('taken');
    if (byMe) {
      // this.setAvatarImage(this.model.config.userAvatarUrl)
      this.startVideo();
    } else {
      if (this.state.inRoom) {
        let video = document.getElementById(`tourRemoteVideo-${videoName}`);
        if (!video) {
          video = await waitForElement(`tourRemoteVideo-${videoName}`);
          this.startVideo(video);
          this.isPlaying = true;
        }
        else {
          this.startVideo(video);
          this.isPlaying = true;
        }

      }
      else {
        this.mesh.visible = false;
        this.setAvatarImage(this.state.avatarImage);
      }
    }
    switch (this.model.onTourScreenShare) {
      case (SCREEN_SHARE_SEAT_TYPE.CHAIR):
        // this.chairMesh.visible = true;
        break;
      case (SCREEN_SHARE_SEAT_TYPE.SEAT):
        // this.screenShare.visible = true;
        break;
    }
    return;
  }

  showUserOptions() {
    if (this.state.byMe) {
      $("#tour-screen-share-menu").addClass("is-active");
    }
  }

  hideUserOptions() {
    $("#tour-screen-share-menu").removeClass("is-active");
  }

  standUp() {
    this.mesh.visible = false;
    // this.chairMesh.visible = false;
    // this.screenShare.visible = false;
    $(`.indicator-${this.mesh.id}`).removeClass('taken');
    // this.hideUserOptions();
    this.userData = null;
    this.isPlaying = false;
    // this.requestAudioLevels = false;
    // this.stopAudioLevelsAnalyzer();
    // clearInterval(this.autoSendVolume)
    // this.autoSendVolume = null;
    this.hideUserOptions();
  }

  startVideo(videoElement, streamId, streamWidth, streamHeight) {
    videoElement = videoElement || document.getElementById(`myTourVideoScreenshare`);
    this.videoElement = videoElement;
    if (!this.videoElement.srcObject) {
      const onMetaDataCallback = () => {
        this.videoElement.removeEventListener("loadedmetadata", onMetaDataCallback)
        this.startVideo(videoElement, streamId, streamWidth, streamHeight);
      }
      this.videoElement.addEventListener("loadedmetadata", onMetaDataCallback);
      return;
    }
    console.log(this.videoElement)
    console.log("this.videoElement")
    console.log(this.videoElement.srcObject)
    console.log("this.videoElement.srcObject")
    const srcObj = videoElement.srcObject;
    this.screenStream = srcObj.getVideoTracks()[0];

    console.log('startVideo!', videoElement.srcObject);

    const tex = new VideoTexture(videoElement);
    this.videoMaterial.map = tex;
    tex.needsUpdate = true;
    this.mesh.material = this.videoMaterial;

    this.mesh.visible = true;
    this.mesh.material.needsUpdate = true;

    if (this.model.onTourScreenShare === SCREEN_SHARE_SEAT_TYPE.CHAIR) {
      this.mesh.geometry = this.chairGeometry
    }
    if (this.model.onTourScreenShare === SCREEN_SHARE_SEAT_TYPE.SCREEN_SHARE_SEAT_TYPE) {
      this.mesh.geometry = this.screenShareGeometry
    }

    // this.audioLevelsAnalyzer(videoElement.srcObject);
    this.setScreenGeometry()
    return true;
  }

  occupySeat(userData) {
    this.userData = userData;
    // this.takeSeat();
  }
  setScreenGeometry = () => {
    // console.log('setScreenGeometry  ',this.screenStream.getSettings());
    let aspectRatio = this.screenStream.getSettings().aspectRatio;
    if (aspectRatio == undefined) {
      aspectRatio = 16 / 9;
    }
    let w = 1;
    let h = 1;

    if (aspectRatio < 1) {
      // portrait
      w = 360 * aspectRatio;
      h = 360;
    } else {
      // landscape
      w = 480;
      h = 480 / aspectRatio;
    }

    this.lastKnownAspectRatio = aspectRatio;
    let videoGeometry = this.getBorder(w, h, 2);

    this.mesh.menuPosition.position.y = 0;
    this.mesh.menuPosition.translateY((h / 2 + 15) * -1);

    this.mesh.geometry = new BufferGeometry();
    this.mesh.geometry.setAttribute('position', new BufferAttribute(new Float32Array(videoGeometry[0]), 3));
    this.mesh.geometry.setAttribute('uv', new BufferAttribute(new Float32Array(videoGeometry[1]), 2));

    let videoBorderGeometry = this.getBorder(w + 4, h + 4, 2);
    // this.borderMesh.geometry = new BufferGeometry();
    // this.borderMesh.geometry.setAttribute('position', new BufferAttribute(new Float32Array(videoBorderGeometry[0]), 3));
    // this.borderMesh.geometry.setAttribute('uv', new BufferAttribute(new Float32Array(videoBorderGeometry[1]), 2));
    // this.mesh.add(this.borderMesh);
    // this.borderMesh.visible = true;

    this.mesh.material.needsUpdate = true;

  }
  setAvatarImage(url, apply = true) {
    console.log('setAvatarImage');
    fetch(url, { method: 'HEAD' })
      .then(res => {
        if (res.ok) {
          //console.log('Image exists.');
          const tex = textureLoader.load(url);
          this.material.map = tex;
          if (apply) {
            this.mesh.material = this.material;
          }
        } else {
          this.material.map = defaultTexture;
          if (apply) {
            this.mesh.material = this.material;
          }
        }
      }).catch(err => console.log('Error:', err));
  }

  getState() {
    let user;
    const _occupiedBy = this.isSeatOccupiedByUser();
    if (!_occupiedBy) {
      this.state =
      {
        occupied: false,
        avatarImage: null,
        videoId: null,
        byMe: false,
        inRoom: false,
        videoName: "",
      }
      return this.state;

    } if (_occupiedBy) {
      const data = this.model.socket.getUsersObject()[_occupiedBy];
      const { userAvatarUrl, userId } = data;
      const byMe = data.userId === this.model.config.userId;
      this.state = {
        avatarImage: userAvatarUrl,
        occupied: userId,
        byMe: byMe,
        inRoom: this.model.tourModeController.roomJoined,
        videoName: `${this.videoId}${userId}`,
      }
    }
    return this.state;
  }

}

export { VRTourScreenShare };
